import React, { Component } from 'react'
import { render } from 'react-dom'

import '../../App.js'

import { InlineMath, BlockMath } from 'react-katex'

import {
  Header,
} from 'semantic-ui-react'

import 'katex/dist/katex.min.css';

class Chapter105 extends Component {
  render() {
    return (
      <div className="base">

        <Header as='h1'>
        1-5. 売り上げを支配する重要な式
        </Header>

　この章で重要なのは、表９−５であり、消費者全体がどの「カテゴリー」、もしくは、「ブランド」を選ぶかは負の二項分布に従い、それぞれの平均購入回数<InlineMath>{`\\displaystyle M `}</InlineMath>や、分布を決定するパラメタ<InlineMath>{`\\displaystyle K `}</InlineMath>がどのように決定されるか示されています。「カテゴリー」を表現した式も、「ブランド」を表現した式もほぼ同じような数式で表現されています。違うのは添字ぐらいでしょうか。 <br/>

　本書を理解する上で重要だと思われる点はパラメタ<InlineMath>{`\\displaystyle K `}</InlineMath>の説明がされているP258の中段の説明になります。 <br/>

　パラメタ<InlineMath>{`\\left(k_j \\right) `}</InlineMath>は、最初にあった赤玉の<InlineMath>{`\\displaystyle \\left(\\theta_j \\right)`}</InlineMath> を1回ずつ袋に足す玉の数<InlineMath>{`\\displaystyle\\left(d_i \\right)`}</InlineMath> 割った値で<InlineMath>{`\\theta_j`}</InlineMath> の関数です。分散の式が示すように、赤玉が多くなる（プリファレンスが増える）事により分散が大きくなり、浸透率<InlineMath>{`\\theta`}</InlineMath>に対しての微分が示すように、より多くの人に広がります。市場の構造上のプリファレンスが高くなれば、より人々に広がります。 <br/>

　すなわち、<InlineMath>{`\\displaystyle K `}</InlineMath>というのは、プリファレンスの関数であり、プリファレンスが増加するごとに、増加するする値である事が説明されています。 <br/>

　負の二項分布は、

<BlockMath>{`
 P\\left(r \\right) = \\frac{\\left(1 + \\frac{M}{K} \\right)^{-K} \\cdot \\Gamma\\left(K + r \\right)}{\\Gamma\\left(r + 1 \\right)\\cdot \\Gamma\\left(K \\right)} \\cdot \\left(\\frac{M}{M+K} \\right)^r \\cdots \\left(1 \\right)
`}</BlockMath>

と表され、<InlineMath>{`\\displaystyle M `}</InlineMath>はプリファレンスであり、<InlineMath>{`\\displaystyle K `}</InlineMath>がプリファレンスの関数であれば、<InlineMath>{`P\\left(r \\right)`}</InlineMath>は<InlineMath>{`\\displaystyle M `}</InlineMath>のみをパラメタに持つ関数という事になります。これは本書で筆者たちがいい関して主張している結論になります。 <br/>

      </div>
    )   
  }
}

export default Chapter105;
